module.exports = __webpack_public_path__ + "static/media/11. Cristal colgante. Resina cristal. 240 x 125 x 2 cm. 2020 copy.95205867.png";